import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { TipoContratoOptions } from 'services/tipo_contrato';
import { Container } from './styles';

interface FollowupBiddingModalProps {
  showModalContracts: boolean;
  setShowModalContracts: React.Dispatch<React.SetStateAction<boolean>>;
  contracts: any;
}

const ContractBiddingModal: React.FC<FollowupBiddingModalProps> = ({
  showModalContracts,
  setShowModalContracts,
  contracts,
}) => {
  return (
    <Modal show={showModalContracts} size="xl" aria-labelledby="contained-modal-title-vcenter">
      <Container>
        <div className="modal-content">
          <div className="modal-header text-white">
            <h5 className="modal-title">Contrato</h5>
            <button
              type="button"
              className="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowModalContracts(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div id="accordion">
              {contracts?.map((contract: any) => {
                return (
                  <>
                    <div className="row bidding-info">
                      <div className="col-md-5 d-flex align-items-center mb-2">
                        <div className="bidding-info-title mr-2 text-nowrap">Valor Estimado:</div>
                        <div className="d-flex align-items-center">
                          <span className="bg-warning px-1">
                            {`R$ ${contract?.valor_contratado
                              .toString()
                              .replace('.', ',')
                              .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}`}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-7 d-flex mb-2">
                        <div className="bidding-info-title text-nowrap mr-2">
                          Empresa Contratada:
                        </div>
                        <div className="d-flex align-items-center">
                          <p>{`${contract?.nome_fornecedor} - ${contract?.cpf_cnpj}`}</p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row bidding-info">
                      <div className="col-md-5 d-flex align-items-center mb-2">
                        <div className="bidding-info-title mr-2 text-nowrap">Tipo</div>
                        <div className="d-flex align-items-center">
                          <span className="px-1">
                            {TipoContratoOptions.find(
                              (option) => option.value === contract?.tipo_contrato_id,
                            )?.label || '-'}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-7 d-flex mb-2">
                        <div className="bidding-info-title text-nowrap mr-2">
                          Receita ou Despesa
                        </div>
                        <div className="d-flex align-items-center">
                          <p>Despesa</p>
                        </div>
                      </div>
                    </div>
                    <div className="row bidding-info">
                      <div className="col-md-5 d-flex align-items-center mb-2">
                        <div className="bidding-info-title mr-2 text-nowrap">Fonte</div>
                        <div className="d-flex align-items-center">
                          <span className="px-1">{contract?.fonte}</span>
                        </div>
                      </div>
                      <div className="col-md-7 d-flex mb-2">
                        <div className="bidding-info-title text-nowrap mr-2">Id contrato PNCP:</div>
                        <div className="d-flex align-items-center">
                          <p>{contract?.contrato_pncp_id}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row bidding-info">
                      <div className="col-md-5 d-flex align-items-center mb-2">
                        <div className="bidding-info-title mr-2 text-nowrap">Data Fonte</div>
                        <div className="d-flex align-items-center">
                          <span className="px-1">
                            {moment(contract?.data_publicaca).format('L')}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-7 d-flex mb-2">
                        <div className="bidding-info-title text-nowrap mr-2">
                          Id contratação PNCP:
                        </div>
                        <div className="d-flex align-items-center">
                          <p>{contract?.id_contrato}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row bidding-info">
                      <div className="col-md-12 d-flex align-items-center mb-2">
                        <div className="bidding-info-title mr-2 text-nowrap">Data Assinatura</div>
                        <div className="d-flex align-items-center">
                          <span className="px-1">
                            {moment(contract?.data_assinatura).format('L')}
                          </span>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <h6>Contratos:</h6>
                    {contract?.files?.map((file: any, index: any) => (
                      <div key={file.id || index} className="row border m-0 p-3">
                        <div className="col-md-5">{file.document_title}</div>
                        <div className="col-md-5">
                          {moment(file?.publication_date_pncp).format('L')}
                        </div>
                        <div className="col-md-2">
                          {' '}
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                            download
                          >
                            Fazer download <i className="oi oi-data-transfer-download ml-1" />
                          </a>
                        </div>
                      </div>
                    ))}
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};
export default ContractBiddingModal;
